export default __webpack_public_path__ + "2e5cdec9e4bc7cea49fac0938e4904e0.png";